<ul class="progress" [ngClass]="{ 'progress--read-only': isReadOnly }">
  <ng-content></ng-content>
</ul>
